<i18n lang="yaml">
  en:
    meta:
      title: Frequently asked questions
      description: Frequently asked questions
    categories:
      - Savings
      - Compatibility
      - Usage
  fr:
    meta:
      title: Foire aux questions
      description: Foire aux questions
    categories:
      - Économies
      - Compatibilité
      - Utilisation
</i18n>

<template>
  <vue-section>
    <default-hero :title="$t('meta.title')" />
    <div class="grid">
      <div class="grid__row">
        <div class="grid__col-12--xxs grid__col-8--s grid__push-2--s">
          <div
            v-for="category in categories"
            :key="category"
            class="space-mb-10"
          >
            <h2 class="type-title-secondary || space-mb-3">{{ category }}</h2>
            <ul>
              <article
                v-for="(question, index) in getQuestionsByCategory(category)"
                :key="index"
              >
                <hr v-if="index > 0" class="hr color-grey" />
                <div
                  class="question flex align-center justify-between space-py-4"
                  :class="question.isOpen ? 'is-open' : ''"
                  @click="() => question.isOpen = !question.isOpen"
                >
                  <!-- eslint-disable vue/no-v-html -->
                  <div class="type-weight-700 space-pr-4" v-html="question.title" />
                  <!-- eslint-enable vue/no-v-html -->
                  <div>
                    <vue-icon class="color-green" name="icon-arrow-down" />
                  </div>
                </div>
                <collapse-transition>
                  <vue-wysiwyg v-if="question.isOpen">
                    <!-- eslint-disable vue/no-v-html -->
                    <!-- <div v-html="question.answer" /> -->
                    <nuxt-content :document="question" />
                    <!-- eslint-enable vue/no-v-html -->
                  </vue-wysiwyg>
                </collapse-transition>
              </article>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </vue-section>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';
import DefaultHero from '~/components/DefaultHero';
import VueIcon from '~/components/Icon';
import VueSection from '~/components/Section';
import VueWysiwyg from '~/components/Wysiwyg';

export default {
  components: {
    CollapseTransition,
    DefaultHero,
    VueIcon,
    VueSection,
    VueWysiwyg,
  },
  nuxtI18n: {
    paths: {
      en: '/faq',
      fr: '/faq',
    },
  },

  head() {
    return {
      title: this.$t('meta.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.description'),
        },
      ],
    };
  },

  data() {
    return {
      categories: Object.values(this.$t('categories')),
    };
  },

  computed: {
    coloredTitle() {
      const title = this.$t('meta.title') || '';
      const [firstWord, ...otherWords] = title.split(' ');
      // eslint-disable-next-line max-len
      return `<span class="color-green">${firstWord}</span> ${otherWords.join(
        ' '
      )}`;
    },
  },

  async asyncData({ app }) {
    const questions = await app.$content(`${app.i18n.locale}/faq`).sortBy('category').sortBy('position', 'asc').fetch();
    questions.forEach(question => question.isOpen = false);
    return { questions };
  },

  methods: {
    getQuestionsByCategory(category) {
      return this.questions.filter(
        question => question.category === category
      );
    },
  },
};
</script>

<style lang="scss">
.question {
  cursor: pointer;

  svg {
    transform: rotate(0);
    transition: transform 0.3s ease-out;
  }

  &.is-open svg {
    transform: rotate(-180deg);
  }
}
</style>
